<template>
  <b-overlay :show="loading" rounded="sm">

    <div class="d-flex flex-column gap-8px Edition">
      <div class="input-title">{{ $t('lbl_EMPBE_ReportAll_Title_ReportEdition') }}</div>
      <selection ControlId="ReportEditionId" label="Name"
                          name="ReportEditions" v-model="ReportEditions.Selected"                     
                          :options="ReportEditions.options" :multiple="false"
                          :clearable="false" 
                          :preselect-first="true">
                        </selection>
    </div>

    <div class="d-flex flex-column gap-8px TakeCount mb-4">
      <div class="input-title mb-0">Take Count</div>
      <b-form-input
        id="report-grid-take"
        type="number"
        v-model.number="take"
        :min="takeMin"
        :max="takeMax"
        class="take-input"
        @change="onTakeInputChange"
        @keyup.enter="onTakeInputChange"
      />
    </div>

    <div class="d-flex flex-column gap-8px mb-4">
      <div class="input-title">{{ $t('lbl_EMPBE_ReportAll_Title_FilterSearch') }}</div>
      <div class="d-flex Grid-ToolBar w-100">
        <div class="Filter-Search d-flex flex-row gap-8px">
          <div class="office-selection"> 
            <selection ControlId="OfficesId" label="Name"
                            name="Offices" v-model="Offices.Selected"
                            :options="Offices.options" :multiple="false"
                            :clearable="false" 
                            :preselect-first="true"></selection>
          </div>
          <div class="SearchBar">
            <b-form-input v-model="SearchKeyWord" :placeholder="$t(`lbl_EMPBE_ReportAll_Title_FilterSearch_PlaceOther`)"  @keyup.enter="GetGridData()"></b-form-input>
            <i v-if="SearchKeyWord" @click="ClearSearch()" class="ClearSearch fa fa-times"></i>
            <i @click="GetGridData()" class="fa fa-search"></i>
          </div>
          <div class="status-selection"> 
            <selection ControlId="StatusId" label="Name"
                            name="Status" v-model="SelectedStatus"
                            :options="StatusOptions" :multiple="false"
                            :clearable="false" 
                            :preselect-first="true"
                            ></selection>
          </div>

        </div>
        <div class="Btn-Group d-flex ml-auto gap-8px">
          <!--TODO: done as component-->
              <Export :SelectedEdition="ReportEditions.Selected"
              :EditionName="GetEditionName"
              :lastUpdate="lastUpdate"
              :GridSelected="GridSelected"
              :IsGridSelectedCrossPage="IsGridSelectedCrossPage"
              :GridSearchQuery="GetQuery"
              :GetSelectedCount="GetSelectedCount"
              :isSuperAdmin="isSuperAdmin"
              >
              </Export>
              <Import :SelectedEdition="ReportEditions.Selected" @SoftReload="SoftReload()"
              :isSuperAdmin="isSuperAdmin">
              </Import>
              <statusChange
              :SelectedEdition="ReportEditions.Selected"
              :GridSearchQuery="GetQuery"
              :GridSelected="GridSelected"
              :IsGridSelectedCrossPage="IsGridSelectedCrossPage"
              :GetSelectedCount="GetSelectedCount"
              @SoftReload="SoftReload()"
              @GridFilter="StatusFilter($event)"
              @SetLoading="SetLoading($event)"
              :GridSelected_Status="GridSelected_Status"
              :isSuperAdmin="isSuperAdmin">
              ></statusChange>
        </div>
        
      </div>

    </div>
    <LocalizationProvider :language="kendoLang">
      <IntlProvider :locale="kendoLang">
          <Grid id="report-grid" ref="grid"
          :resizable="false" :reorderable="true" :sortable="true"  :groupable="false" :selectable="true"
                     :filterable="false" :column-menu="false"   :selected-field="selectedField"
                     :pageable="true" :skip="skip" :take="take" :total="total"
                     :data-items="mappedData" @pagechange="pageChangeHandler"
           :columns="columns" 
            @selectionchange="onSelectionChange"
          @headerselectionchange="onHeaderSelectionChange"
          @rowclick="onRowClick"
           >
           <GridToolbar id="CrossPageSelected" v-if="IsGridSelectedCrossPage">
              <span class="CrossPagePrompt">
                {{   $t("lbl_EMPBE_ReportAll_component_Grid_Text",{totalNumber:total}) }}
              </span>         
           </GridToolbar>

          <template v-slot:CompanyNameTemplate="{props}">
            <td>
              <span>
                {{ GetCompanyName(props) }}
              </span>
            </td>
          </template>

          <template v-slot:StatusTemplate="{props}">
            <td>
              <span :class="`StatusPill Status_${props.dataItem.StatusCode}`">
                {{ $t(`lbl_EMPBE_AutoReport_${props.dataItem.StatusCode}`)  }}
              </span>
            </td>
          </template>

          </Grid>
          <ReportIframe :reportIframeItem="reportIframeItem" ref="childRef" @changeIframeStrus="changeIframeMethods"
          :isSuperAdmin="isSuperAdmin">

          </ReportIframe>
      </IntlProvider>
    </LocalizationProvider>
  </b-overlay>
</template>

<script>

import DialogModal from '../../../components/popup/dialogModal.vue'
import { Grid, GridToolbar } from "@progress/kendo-vue-grid";
import { LocalizationProvider, IntlProvider } from '@progress/kendo-vue-intl';
import { reportService } from '@/_services/report.service';  
import { OfficesOptions, GridColumn, Status} from '../const'
import Export from './export'
import Import from './import'
import statusChange from './statusChange.vue'
import ReportIframe from './ReportIframe.vue'
import { process } from "@progress/kendo-data-query";

export default{
      components:{
        Grid, 
        GridToolbar,
        LocalizationProvider,
        IntlProvider,
        Export : Export,
        Import,
        statusChange,
        ReportIframe,
        DialogModal
      },
      data(){
        return{
              IframeStrus:false,
              reportIframeItem:
              {
                LastUpdate:"",
                EmpCompanyId:"",
                ReportEdition:"",
                StatusCode:""
              },
              loading:false,
              ReportEditions:{
                options: [],
                Selected: "",
              },
              Offices:{
                options: [
                            { id: 'All', label: this.$t(`lbl_EMPBE_ReportAll_Title_AllOffices`) },
                            { id: 'BJO', label: 'BJO' },
                            { id: 'HKO', label: 'HKO' },
                            { id: 'SGO', label: 'SGO' },
                            { id: 'SHO', label: 'SHO' },
                            { id: 'SZO', label: 'SZO' }
                        ],
                Selected: "All"
              },
              lastUpdate: [],
              columns:[
                    {
                      field: 'selected',
                      width: '40px',
                      columnMenu: false,
                      // className: 'text-center',
                      headerSelectionValue: false,
                    }                   ,
                    {
                        field: "SalesOffice",
                        title: 'CRM '+this.$t(`lbl_EMPBE_ReportAll_Table_SalesOffice`),
                        width: '130'
                        // cell: "EndProductNameTemplate",
                    },
                    {
                        field: "salesCode",
                        title: 'CRM '+this.$t(`lbl_EMPBE_ReportAll_Table_SalesCode`),
                        width: '130'
                        // cell: "EndProductNameTemplate",
                    },
                    {
                        field: "SalesOffice_Pub",
                        title: 'PUB '+ this.$t(`lbl_EMPBE_ReportAll_Table_SalesOffice`),
                        width: '130'
                        // cell: "EndProductNameTemplate",
                    },
                    {
                        field: "salesCode_Pub",
                        title: 'PUB ' + this.$t(`lbl_EMPBE_ReportAll_Table_SalesCode`),
                        width: '130'
                        // cell: "EndProductNameTemplate",
                    },
                    {
                        field: "CompanyName",
                        title: this.$t(`lbl_EMPBE_ReportAll_Table_CompanyName`),
                        cell: "CompanyNameTemplate",
                        width: '160',
                    },
                    {
                        field: "EBoothGrade",
                        title: this.$t(`lbl_EMPBE_ReportAll_Table_EBoothGrade`),
                        width: '100',
                        // cell: "ThemeTemplate",
                    },
                    {
                        field: "SponsorShip",
                        title: this.$t(`lbl_EMPBE_ReportAll_Table_SponsorShip`),
                        // cell: "SponsorshipTemplate",
                        width: '150',
                    },
                    {
                        field: "Status",
                        title: this.$t(`lbl_EMPBE_ReportAll_Table_Status`),
                        cell: "StatusTemplate",
                        width: '150',
                    },
                    {
                        field: "LastUpdate",
                        title: this.$t(`lbl_EMPBE_ReportAll_Table_LastRevise`),
                        width: '150',
                        // cell: "LastSubmissionDateTemplate",
                    },
                    {
                        field: "TotalSent",
                        title: this.$t(`lbl_EMPBE_ReportAll_Table_TotalSent`),
                        width: '120',
                    },
                    {
                        field: "LastSent",
                        title: this.$t(`lbl_EMPBE_ReportAll_Table_LastSent`),
                        width: '150',
                    } 
              ],   
              selectedField :'selected',
              mappedData : [],
              skip: 0,
              take: 50,
              takeMin: 10,
              takeMax: 500,
              total:0,
              GridLoader: false,
              FirstLoad : true,
              SearchKeyWord : "",
              SelectedStatus : "All",
            }
          

      },
      async created(){
        await this.GetReportEditions();
        this.GetGridData();
      },
      computed:{
        kendoLang() {
            var langid = localStorage.getItem("currentLangId");
            switch (langid) {
                case "1252":
                return "en-US";
                case "950":
                return "zh-Hant";
                case "936":
                return "zh-Hans";
                default:
                return "zh-Hans";
            }
        },
        GetEditionName(){
          const editionId = this.ReportEditions.Selected
          return this.ReportEditions.options.find(x=> x.id == editionId)?.label
        },
        GetQuery(){
          var query  = {
            searchKeyword : this.SearchKeyWord,
            skip: this.skip,
            take: this.take,
            SalesOffice : this.Offices.Selected,
            ReportEdition : this.ReportEditions.Selected,
            StatusCode : this.SelectedStatus
          }
          console.log(query)
          return query;
        },
        IsGridSelectedCrossPage(){
          return this.columns[0].headerSelectionValue
        },
        GetSelectedCount(){
            if(this.IsGridSelectedCrossPage){
                return this.total
            }
            return this.GridSelected.length
        },
        GridSelected(){
          return this.mappedData.filter(x=> x.selected).map(x=> x.EmpCompanyId)
        },
        GridSelected_Status(){
          return this.mappedData.filter(x=> x.selected).map(x=> x.StatusCode)
        },
        StatusOptions(){
          return Status.map((x)=> ({
            label : this.$t(`lbl_EMPBE_AutoReport_${x.label}`), 
            id : x.id
           })
          ) 
        },
        isSuperAdmin() {              
            return this.$store.state.authentication.user.Permissions.some(x => x == '999150' || x == '9991') ;
        },
      },
      methods:{
        
         changeIframeMethods(data){
          this.IframeStrus=data;
        },
        async GetReportEditions(){
          await reportService.GetReportEditions().then( res=>{
              const EditionsData = res.data;
              var langid = localStorage.getItem("currentLangId");
              // map data for selection
              this.ReportEditions.options = EditionsData.map(x=> (
                { id : x.batchID,
                  label :langid==1252 ? x.name :(langid==936 ? x.nameSc: x.nameTc) //this.$t(x.name)
                })        
              )       
              this.ReportEditions.Selected = (this.ReportEditions.options)[0].id;
          })         
        },
        onRowClick: function (event) {
           this.IframeStrus=true;
           this.reportIframeItem.EmpCompanyId = event.dataItem.EmpCompanyId;
           this.reportIframeItem.LastUpdate = event.dataItem.LastUpdate;
           this.reportIframeItem.ReportEdition = this.GetQuery.ReportEdition;
            this.reportIframeItem.StatusCode=event.dataItem.StatusCode;
           this.$refs.childRef.GetData(); 
          },
        Search(){
          console.log("search")
        },
        GetGridData(){
          var that = this;
          this.loading = true;
          reportService.GetTrafficReport_Grid(this.GetQuery).then( res=>{
              const RawData = res.data;
              this.lastUpdate = res.data.lastUpdate
              that.MapDataToGrid(RawData);

              // this.ReportEditions.Selected = (this.ReportEditions.options)[0].id;
          }).finally( _ => {
            that.loading = false;
          })
        },
        MapDataToGrid(RawData){
          const rawGridData = RawData.results
          this.total = RawData.totalResultNo
          
          this.mappedData = rawGridData.map((x) => ({
              SalesOffice: x.salesOffice,
              CompanyReportId: x.companyReportId,
              EmpCompanyId: x.empCompanyId,
              CompanyNameCH: x.companyNameCH,
              CompanyNameEN: x.companyNameEN,
              EBoothGrade: x.eBoothGrade,
              SponsorShip: x.sponsorPackage,
              StatusCode: x.statusCode,
              LastUpdate: x.lastUpdate,
              TotalSent: x.totalSent,
              LastSent: x.lastSent,
              RevisionTime : x.revisionTime,
              salesCode : x.salesCode,
              selected : false,
              //[20092024][SJP] Add Pub salescode and sales' id
              SalesOffice_Pub : x.salesOffice_Pub,
              salesCode_Pub: x.salesCode_Pub
          }));

        },
        pageChangeHandler: function (event) {
          this.loader = true;
          this.skip = event.page.skip;
          this.take = event.page.take;
          this.SoftReload();
        },
        GetCompanyName(props){
          var langid = localStorage.getItem("currentLangId");
          return langid == 1252 ? props.dataItem.CompanyNameEN : props.dataItem.CompanyNameCH
        },
        onHeaderSelectionChange (event) {
            let checked = event.event.target.checked;
            this.columns[0].headerSelectionValue = checked ? true : false; //tick header checkbox
            this.mappedData = this.mappedData.map((item) => { return {...item, selected: checked} });
        },
        onSelectionChange (event) {
            //If it is a untick event, untick the check all tickbox
            if(event.dataItem[this.selectedField]){
              this.columns[0].headerSelectionValue = false;
            }
            event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
            
        },
        SoftReload(){
          this.columns[0].headerSelectionValue = false // untick the header checkbox
          this.mappedData = this.mappedData.map((item) => { return {...item, selected: false} });
          this.GetGridData();
        },
        StatusFilter(Status){
          this.SelectedStatus = Status
        },
        SetLoading(status){
            this.loading = status;
        },
        ClearSearch(){
          this.SearchKeyWord = "";
          this.SoftReload();
        },
        onTakeInputChange(){
          let val = Number(this.take);
          if (!Number.isFinite(val) || val < this.takeMin) val = this.takeMin;
          if (val > this.takeMax) val = this.takeMax;
          this.take = val;
          this.skip = 0;
          this.GetGridData();
        },

      },
      watch:{
        "Offices.Selected":{
          handler(newVal, oldVal) {
            this.skip = 0;
            this.SoftReload()
          },
          deep: true,
        },
        "SelectedStatus":{
          handler(newVal, oldVal) {
            this.skip = 0;
            this.SoftReload()
          },
          deep: true,
        },
        "ReportEditions.Selected":{
          handler(newVal, oldVal) {
            if(this.FirstLoad){
              this.FirstLoad = false;
            }
            else{
              this.skip = 0;
              this.GetGridData()
            }    
          },
          deep: true,
        },
        IframeStrus()
        {
          if(this.IframeStrus)
          {
            document.body.style.overflowY = 'hidden'
          }else
          {
            document.body.style.overflowY = 'scroll'
          }
        }

      }
    }
</script>

<style lang="scss">
  @import "../style/grid"; 
  #report .modal-dialog {  
  width: 80%; /* 或者任何你需要的宽度值 */  
  max-width: none; /* 如果需要，可以移除最大宽度限制 */  
}
#report .DialogPadding
{
  padding: 0px !important;

}
</style>
